export const loadPermissions = {
    INVOICE: {
        key: 'Load.Invoice',
        name: 'View Invoice Data',
    },
    LOAD_CREATE: {
        key: 'loads.create',
        name: 'Create Loads',
    },
    LOAD_EDIT: {
        key: 'loads.edit',
        name: 'Edit Load',
    },
    LOAD_APPROVE_PRICE: {
        key: 'loads.approve.price',
        name: 'Approve Load Price',
    }
}